// Better Systems AI marketing visual system.
// Black / off-white / electric green. Hormozi lead-page clarity.
// Do not reuse the old navy / orange / cream yards system.

export const MKT = {
  ink: "#0B0B0B",
  paper: "#F4F2EC",
  paper2: "#EDEAE2",
  accent: "#C6FF3D",
  accentInk: "#0B0B0B",
} as const;

export function BSABrandStyles() {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Inter:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />
      <style>{`
        .font-display,
        .bsa-heading,
        .mkt-page h1,
        .mkt-page h2 {
          font-family: 'Instrument Serif', Georgia, serif;
          letter-spacing: -0.03em;
          font-weight: 400;
        }
        .font-heading { font-family: 'Inter', system-ui, sans-serif; letter-spacing: -0.02em; }
        .font-body { font-family: 'Inter', system-ui, sans-serif; }
        .font-mono { font-family: 'Inter', system-ui, sans-serif; letter-spacing: 0.04em; }

        :root {
          --mkt-ink: ${MKT.ink};
          --mkt-paper: ${MKT.paper};
          --mkt-paper-2: ${MKT.paper2};
          --mkt-accent: ${MKT.accent};
          --mkt-accent-ink: ${MKT.accentInk};
          --bsa-navy: ${MKT.ink};
          --bsa-navy-2: #1a1a1a;
          --bsa-orange: ${MKT.accent};
          --bsa-orange-2: #d8ff6a;
          --bsa-cream: ${MKT.paper};
          --bsa-concrete: ${MKT.paper2};
          --bsa-text-mute: #5c5c5c;
        }

        .blueprint-grid,
        .blueprint-grid-dark,
        .grain::after {
          background-image: none;
        }
        .grain::after { display: none; }

        .cta-primary,
        .cta-orange {
          background: var(--mkt-accent);
          color: var(--mkt-accent-ink);
          font-family: 'Inter', system-ui, sans-serif;
          font-weight: 800;
          letter-spacing: -0.01em;
          text-transform: none;
          border-radius: 0;
          box-shadow: none;
        }
        .cta-primary:hover,
        .cta-orange:hover {
          background: #d8ff6a;
          transform: none;
          color: var(--mkt-accent-ink);
        }

        .mkt-page a:hover { color: inherit; }

        html:has(.mkt-page),
        body:has(.mkt-page),
        #root:has(.mkt-page) {
          background-color: #F4F2EC !important;
        }

        .cta-primary,
        .cta-orange {
          border-radius: 0 !important;
        }
      `}</style>
    </>
  );
}
